import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import { ChevronLeft, MoreVert } from "@mui/icons-material";
import axios from "axios";
import apiConfig from "../../utilities/apiConfig.json";
import serverConfig from "../../utilities/serverConfig.json";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import haveAccess from "../../utilities/functions/haveAccess";
import CancelIcon from "./../../assets/images/icons/Google SVGs/cancel.svg";
import AddCircleIcon from "./../../assets/images/icons/Google SVGs/add_circle.svg";
import LocationOnIcon from "./../../assets/images/icons/Google SVGs/location_on.svg";
import { ReactComponent as ArrowRightAltIcon } from "./../../assets/images/icons/Google SVGs/arrow_right_alt.svg";
import RemoveIcon from "./../../assets/images/icons/Google SVGs/remove(red).svg";
import AddIcon from "./../../assets/images/icons/Google SVGs/add.svg";
import SecretaryNotFound from "./../../assets/images/icons/Google SVGs/Secretary.svg";

const PlaceCard = (props) => {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);

  const { token, roles } = useSelector((state) => state.user);
  const tokenLocal = localStorage.getItem("token");

  const headers = {
    Authorization: "Bearer " + (token ? token : tokenLocal),
  };

  const [headerTitle, setHeaderTitle] = useState("");

  const [assignedDepartments, setAssignedDepartments] = useState([]);
  const [remainingDepartments, setRemainingDepartments] = useState([]);
  const [department, setDepartment] = useState({
    id: null,
    title: null,
    biography: null,
  });
  const [departmentBio, setDepartmentBio] = useState("");
  const [departmentPhone, setDepartmentPhone] = useState("");

  const [departmentSearch, setDepartmentSearch] = useState("");
  const [doctorSearch, setDoctorSearch] = useState("");
  const [secretarySearch, setSecretarySearch] = useState("");

  const [assignedDoctors, setAssignedDoctors] = useState([]);
  const [remainingDoctors, setRemainingDoctors] = useState([]);

  const [assignedSecretaries, setAssignedSecretaries] = useState([]);
  const [resultSecretary, setResultSecretary] = useState({
    first_name: null,
    last_name: null,
    mobile: null,
    file: null,
  });

  const [readDocSec, setReadDocSec] = useState(false);

  const [docOrnot, setDocOrNot] = useState(true);
  // #region read doctors of department place
  const getDoctorsAPI = () => {
    setLoading(true);
    axios
      .post(
        serverConfig.server.url +
        apiConfig.api.getAPIs.getDoctorsForDepartmentPlace +
        props.id +
        "/all-doctors",
        {
          department_id: department.id ? department.id : null,
        },
        { headers }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          setAssignedDoctors(response.data.data.doctors_list);
          setRemainingDoctors(response.data.data.other_doctors);
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };
  // #endregion

  // #region search secretary of department place
  // const searchSecretaryAPI = () => {
  //   setLoading(true);
  //   axios
  //     .post(
  //       serverConfig.server.url + apiConfig.api.userControllers.searchUser,
  //       {
  //         mobile: secretarySearch,
  //       },
  //       { headers }
  //     )
  //     .then((response) => {
  //       setLoading(false);
  //       if (response.data.status === "success") {
  //         setResultSecretary({
  //           first_name: response.data.data.first_name,
  //           last_name: response.data.data.last_name,
  //           mobile: response.data.data.last_name,
  //           file: response.data.data.file,
  //         });
  //       } else if (response.data.code == 404) {
  //       } else {
  //         if (typeof response.data.errors === typeof "String") {
  //           toast.error(response.data.errors);
  //         } else {
  //           response.data.errors.forEach((element) => {
  //             toast.error(element);
  //           });
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       toast.error("Error making API call:", error);
  //     });
  // };
  // #endregion

  // #region read secretaries of department place
  const getSecretariesAPI = () => {
    setLoading(true);
    axios
      .post(
        serverConfig.server.url +
        apiConfig.api.getAPIs.getSecretariesForDepartmentPlace +
        props.id +
        "/secretaries",
        {
          department_id: department.id ? department.id : null,
        },
        { headers }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          setAssignedSecretaries(response.data.data.secretaries_list);
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };
  // #endregion

  // #region read deps of place
  const getDepartmentsAPI = () => {
    setLoading(true);
    axios
      .get(
        serverConfig.server.url +
        apiConfig.api.getAPIs.getDepartmentsForPlace +
        props.id +
        "/departments",
        { headers }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          setAssignedDepartments(response.data.data.departments_list);
          setRemainingDepartments(response.data.data.other_departments);
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };
  // #endregion

  // #region remove dep from place
  const removeDepartmentAPI = (department) => {
    if (department.is_used == true) {
      toast.warning(
        `برای حذف دپارتمان ${department.title}، ابتدا پزشکان این دپارتمان را حذف کنید`
      );
    } else {
      setLoading(true);
      axios
        .post(
          serverConfig.server.url +
          apiConfig.api.deleteAPIs.deleteDepartmentPlace,
          {
            place_id: props.id,
            department_id: department.id,
          },
          {
            headers,
          }
        )
        .then((response) => {
          setLoading(false);
          if (response.data.status === "success") {
            toast.success(response.data.message);
            getDepartmentsAPI();
          } else {
            if (typeof response.data.errors === typeof "String") {
              toast.error(response.data.errors);
            } else {
              response.data.errors.forEach((element) => {
                toast.error(element);
              });
            }
          }
        })
        .catch((error) => {
          setLoading(false);
          toast.error("Error making API call:", error);
        });
    }
  };
  // #endregion

  // #region add dep to place
  const addDepartmentAPI = () => {
    setLoading(true);
    axios
      .post(
        serverConfig.server.url + apiConfig.api.addAPIs.addDepartmentPlace,
        {
          place_id: props.id,
          department_id: department.id,
          phone: departmentPhone,
          biography: departmentBio,
        },
        {
          headers,
        }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          toast.success(response.data.message);
          getDepartmentsAPI();
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };
  // #endregion

  // #region add doctor to department place
  const addDoctorToDepartmentPlaceAPI = (doctorID) => {
    setLoading(true);
    axios
      .post(
        serverConfig.server.url +
        apiConfig.api.addAPIs.addDoctorsToDepartmentPlace,
        {
          place_id: props.id,
          department_id: department.id,
          user_id: doctorID,
        },
        {
          headers,
        }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          toast.success(response.data.message);
          getDoctorsAPI();
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };
  // #endregion

  // #region add secretary from department place
  const addSecretaryToDepartmentPlaceAPI = (mobile, first_name, last_name) => {
    setLoading(true);
    axios
      .post(
        serverConfig.server.url +
        apiConfig.api.addAPIs.addDoctorsToDepartmentPlace,
        {
          place_id: props.id,
          department_id: department.id,
          mobile: mobile ? mobile : null,
          first_name: first_name ? first_name : null,
          last_name: last_name ? last_name : null,
          role: "secretary",
        },

        {
          headers,
        }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          toast.success(response.data.message);
          getSecretariesAPI();
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };
  // #endregion

  // #region remove secretary from department place
  const removeSecretaryFromDepartmentPlaceAPI = (secretaryId) => {
    setLoading(true);
    axios
      .post(
        serverConfig.server.url +
        apiConfig.api.deleteAPIs.deleteDoctorFromDepartmentPlace,
        {
          place_id: props.id,
          department_id: department.id,
          user_id: secretaryId,
        },
        {
          headers,
        }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          toast.success(response.data.message);
          getSecretariesAPI();
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };
  // #endregion

  // #region remove doctor from department place
  const removeDoctorFromDepartmentPlaceAPI = (doctorID) => {
    setLoading(true);
    axios
      .post(
        serverConfig.server.url +
        apiConfig.api.deleteAPIs.deleteDoctorFromDepartmentPlace,
        {
          place_id: props.id,
          department_id: department.id,
          user_id: doctorID,
        },
        {
          headers,
        }
      )
      .then((response) => {
        setLoading(false);
        if (response.data.status === "success") {
          toast.success(response.data.message);
          getDoctorsAPI();
        } else {
          if (typeof response.data.errors === typeof "String") {
            toast.error(response.data.errors);
          } else {
            response.data.errors.forEach((element) => {
              toast.error(element);
            });
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Error making API call:", error);
      });
  };
  // #endregion
  var counting = 0;

  // #region select department from place
  const changeDepartment = (department) => {
    if (department.length == 0) {
      setDepartment({ id: null, title: null, biography: null });
    } else {
      setDepartment({
        id: department.id,
        title: department.title,
        biography: department.biography,
      });
    }
  };
  // #endregion

  useEffect(() => {
    if (readDocSec) {
      setReadDocSec(false);
      docOrnot ? getDoctorsAPI() : getSecretariesAPI();
    }
  }, [readDocSec]);

  return (
    <div>
      <div className="card  border-0 background-bootstrap-gray-100">
        <div className="card-body p-2 fs-14 fw-regular d-flex row bg-transparent">
          <div className="col">
            <div
              className="color-bootstrap-gray-700 text-decoration-none"
              type="button"
              onClick={() => {
                navigate(`/place?${"pl=" + props.id}`);
              }}
            >
              {props.title}
            </div>
            <div className="d-flex color-iso-gray-300 mt-2 fs-12">
              <img src={LocationOnIcon} width={20} alt="" />
              <span className="me-1">{props.city_title}</span>
              <span>
                {"("}
                {props.province_title}
                {")"}
              </span>
            </div>
          </div>
          <div className="col-auto d-flex align-items-center">
            {haveAccess(roles, "place_card_setting") && (
              <div className="dropdown me-1 color-bootstrap-gray-700">
                <IconButton
                  type="button"
                  id="dropdownMenuOffset"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  data-bs-offset="30,-45"
                >
                  <MoreVert />
                </IconButton>

                <ul
                  className="dropdown-menu fit-dropdown w-fit"
                  aria-labelledby="dropdownMenuOffset"
                >
                  {haveAccess(roles, "place_card_show") && (
                    <li
                      className="dropdown-item fs-14"
                      type="button"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate(`/place?${"pl=" + props.id}`);
                      }}
                    >
                      <div className="color-bootstrap-gray-700 text-decoration-none fs-14 w-100 d-block">
                        مشاهده
                      </div>
                    </li>
                  )}
                  {haveAccess(roles, "place_card_edit") && (
                    <li
                      className="dropdown-item fs-14"
                      type="button"
                      onClick={() => {
                        window.scrollTo(0, 0);
                        navigate(
                          `/place-store?${"pl=" + props.id + "&action=edit"}`
                        );
                      }}
                    >
                      <div className="color-bootstrap-gray-700 text-decoration-none fs-14 w-100 d-block">
                        ویرایش
                      </div>
                    </li>
                  )}

                  {haveAccess(roles, "place_card_departments") && (
                    <li
                      className="dropdown-item fs-14"
                      type="button"
                      onClick={() => {
                        getDepartmentsAPI();
                      }}
                      data-bs-toggle="modal"
                      data-bs-target={`#add-remove-departments-modal-${props.id}`}
                    >
                      مدیریت دپارتمان‌ها
                    </li>
                  )}

                  {haveAccess(roles, "place_card_secretaries") && (
                    <li
                      className="dropdown-item fs-14"
                      type="button"
                      onClick={() => {
                        docOrnot && setDocOrNot(false);
                        getDepartmentsAPI();
                        setSecretarySearch("");
                        setResultSecretary({
                          mobile: null,
                          first_name: null,
                          last_name: null,
                        });
                      }}
                      data-bs-toggle="modal"
                      data-bs-target={`#select-departments-modal-${props.id}`}
                    >
                      مدیریت منشی‌ها
                    </li>
                  )}
                  {haveAccess(roles, "place_card_doctors") && (
                    <li
                      className="dropdown-item fs-14"
                      type="button"
                      onClick={() => {
                        !docOrnot && setDocOrNot(true);
                        getDepartmentsAPI();
                      }}
                      data-bs-toggle="modal"
                      data-bs-target={`#select-departments-modal-${props.id}`}
                    >
                      مدیریت پزشکان
                    </li>
                  )}
                </ul>
              </div>
            )}

            {haveAccess(roles, "place_card_show_chevron") && (
              <IconButton
                onClick={() => {
                  navigate(`/place?${"pl=" + props.id}`);
                }}
              >
                <ChevronLeft />
              </IconButton>
            )}
          </div>
        </div>
      </div>

      {/* select department of place modal */}
      <div
        className="modal fade"
        id={`select-departments-modal-${props.id}`}
        tabIndex="-1"
        aria-labelledby={`select-departments-modal-${props.id}-label`}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header border-bottom mx-0 py-2">
              <ArrowRightAltIcon
                className="color-bootstrap-gray-800"
                width={24}
                height={24}
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
              <input
                type="text"
                className="form-control border-0 shadow-none w-100 color-iso-gray"
                placeholder="انتخاب دپارتمان ..."
                value={departmentSearch}
                onChange={(e) => setDepartmentSearch(e.target.value)}
              />
            </div>

            <div className="modal-body">
              {loading && (
                <span
                  className="spinner-border spinner-border ms-1"
                  role="status"
                  aria-hidden="true"
                />
              )}

              <div className="d-flex flex-column align-items-start">
                {assignedDepartments &&
                  assignedDepartments
                    .filter((e) => e.title.includes(departmentSearch))
                    .map((department, index) => (
                      <button
                        key={index}
                        className="btn btn-light w-100 d-flex align-items-start my-2"
                        data-bs-toggle="modal"
                        data-bs-target={`${docOrnot
                          ? "#add-remove-doctors-modal-"
                          : "#add-remove-secretaries-modal-"
                          }${props.id}`}
                        onClick={() => {
                          !docOrnot && setSecretarySearch("");
                          !docOrnot &&
                            setResultSecretary({
                              mobile: null,
                              first_name: null,
                              last_name: null,
                            });

                          setHeaderTitle(department.title);
                          changeDepartment(department);
                          docOrnot ? setReadDocSec(true) : setReadDocSec(true);
                        }}
                      >
                        <div className="d-flex col">{department.title}</div>
                      </button>
                    ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* add or remove doctors of department place modal */}
      <div
        className="modal fade"
        id={`add-remove-doctors-modal-${props.id}`}
        tabIndex="-1"
        aria-labelledby={`add-remove-doctors-modal-${props.id}-label`}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header border-bottom mx-0 py-2">
              <ArrowRightAltIcon
                className="color-bootstrap-gray-800"
                width={24}
                height={24}
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
              <input
                type="text"
                className="form-control border-0 shadow-none w-100 color-iso-gray"
                placeholder="جستجوی دکتر ..."
                value={doctorSearch}
                onChange={(e) => setDoctorSearch(e.target.value)}
              />
            </div>

            <div className="modal-body">
              {loading && (
                <span
                  className="spinner-border spinner-border ms-1"
                  role="status"
                  aria-hidden="true"
                />
              )}
              <div className="d-flex flex-column align-items-start">
                {assignedDoctors &&
                  assignedDoctors
                    .filter(
                      (doctor) =>
                        (doctor.title
                          ? doctor.title.includes(doctorSearch)
                          : "") ||
                        doctor.first_name.includes(doctorSearch) ||
                        doctor.last_name.includes(doctorSearch)
                    )
                    .map((doctor, index) => {
                      return (
                        <div
                          className="btn-group w-100"
                          role="group"
                          aria-label="Basic mixed styles example"
                          key={index}
                        >
                          <button className="btn btn-light w-100 d-flex align-items-start my-2">
                            <div className="d-flex col">
                              {doctor.title ? doctor.title : ""}{" "}
                              {doctor.first_name} {doctor.last_name}
                            </div>
                          </button>
                          <img
                            className="btn btn-light my-2"
                            src={RemoveIcon}
                            alt=""
                            type="button"
                            onClick={() => {
                              removeDoctorFromDepartmentPlaceAPI(doctor.id);
                            }}
                          />
                        </div>
                      );
                    })}
              </div>

              <div className="d-flex flex-column align-items-start">
                {remainingDoctors &&
                  remainingDoctors
                    .filter(
                      (doctor) =>
                        (doctor.title
                          ? doctor.title.includes(doctorSearch)
                          : "") ||
                        doctor.first_name.includes(doctorSearch) ||
                        doctor.last_name.includes(doctorSearch)
                    )
                    .map((doctor, index) => (
                      <div
                        className="btn-group w-100"
                        role="group"
                        aria-label="Basic mixed styles example"
                        key={index}
                      >
                        <button className="btn btn-light w-100 d-flex align-items-start my-2">
                          <div className="d-flex col">
                            {doctor.title ? doctor.title : ""}{" "}
                            {doctor.first_name} {doctor.last_name}
                          </div>
                        </button>
                        <img
                          className="btn btn-light my-2"
                          src={AddIcon}
                          width={53}
                          type="button"
                          onClick={() => {
                            addDoctorToDepartmentPlaceAPI(doctor.id);
                          }}
                        />
                      </div>
                    ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* add or remove secretary of department place modal */}
      <div
        className="modal fade"
        id={`add-remove-secretaries-modal-${props.id}`}
        tabIndex="-1"
        aria-labelledby={`add-remove-secretaries-modal-${props.id}-label`}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content border-radius-16">
            <div className="d-flex align-items-center justify-content-between modal-header border-bottom m-3 mb-0 p-0 pb-2 fs-16 fw-medium color-bootstrap-gray-900">
              <div>
                <h5 className="fs-16 fw-medium mb-1">اختصاص منشی</h5>
              </div>
              <img
                className="d-flex align-self-start"
                src={CancelIcon}
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            <div className="modal-body pt-2">
              {/* <FormControl className="w-100" variant="outlined">
                <OutlinedInput
                  // label="Password"
                  className="border-radius-8 border-bootstrap-gray-500 background-bootstrap-gray-100 p-12px"
                  id="outlined-adornment-password"
                  type="mobile"
                  placeholder="جستجوی موبایل..."
                  value={secretarySearch}
                  onChange={(e) => {
                    setSecretarySearch(e.target.value);
                  }}
                  endAdornment={
                    <InputAdornment position="end" className="me-0">
                      <img
                        src={SearchIcon}
                        type="button"
                        alt=""
                        onClick={() => {
                          setResultSecretary({
                            first_name: null,
                            last_name: null,
                            mobile: secretarySearch,
                            file: null,
                          });
                          searchSecretaryAPI();
                        }}
                        className={`btn btn-light p-1${
                          secretarySearch.length != 11 ? " disabled" : ""
                        }`}
                      />
                    </InputAdornment>
                  }
                />
              </FormControl> */}

              {loading && (
                <span
                  className="spinner-border spinner-border ms-1 my-2"
                  role="status"
                  aria-hidden="true"
                />
              )}

              <span>منشی‌های دپارتمان {headerTitle}</span>
              <div className="d-flex flex-column align-items-start">
                {assignedSecretaries &&
                  assignedSecretaries
                    .filter(
                      (secretary) =>
                        secretary.first_name.includes(doctorSearch) ||
                        secretary.last_name.includes(doctorSearch)
                    )
                    .map((secretary, index) => {
                      return (
                        <div
                          className="btn-group w-100"
                          role="group"
                          key={index}
                        >
                          <button className="btn btn-light w-100 d-flex align-items-start my-2">
                            <div className="d-flex col">
                              <img
                                className="secretary-image-box object-fit-cover me-2"
                                src={
                                  secretary.file
                                    ? secretary.file
                                    : SecretaryNotFound
                                }
                                alt=""
                              />
                              <div className="d-flex row text-start">
                                <div className="fs-14 fw-medium color-bootstrap-gray-800">
                                  {secretary.first_name} {secretary.last_name}
                                </div>
                                <div className="fs-12 fw-normal color-bootstrap-gray-600">
                                  {secretary.mobile}
                                </div>
                              </div>
                            </div>
                          </button>

                          <img
                            className="btn btn-light my-2"
                            src={RemoveIcon}
                            width={53}
                            type="button"
                            onClick={() => {
                              removeSecretaryFromDepartmentPlaceAPI(
                                secretary.id
                              );
                            }}
                          />
                        </div>
                        //           <div className="btn-group w-100" role="group">
                        //   <button className="btn btn-light w-100 d-flex align-items-start my-2">
                        //     <div className="d-flex col">
                        //       <img
                        //         className="secretary-image-box object-fit-cover me-2"
                        //         src={resultSecretary.file}
                        //         alt=""
                        //       />
                        //       <div className="d-flex row text-start">
                        //         <div>
                        //           {resultSecretary.first_name}{" "}
                        //           {resultSecretary.last_name}
                        //         </div>
                        //         <div>{resultSecretary.mobile}</div>
                        //       </div>
                        //     </div>
                        //   </button>
                        //   <button
                        //     type="button"
                        //     className="btn btn-light my-2 material-symbols-rounded color-iso-blue-300"
                        //     onClick={() => {
                        //       addSecretaryToDepartmentPlaceAPI();
                        //     }}
                        //   >
                        //     add
                        //   </button>
                        // </div>
                      );
                    })}
                {!assignedSecretaries && <p>منشی اختصاص داده نشده</p>}
              </div>
              <div className="col-12 mt-2 px-0 d-flex">
                <div className="d-flex justify-content-center pe-2 col-6">
                  <div
                    className="btn btn-primary w-100"
                    data-bs-toggle="modal"
                    data-bs-target={`#add-secretary-modal-${props.id}`}
                    onClick={() => {
                      setResultSecretary((prevState) => ({
                        ...prevState,
                        first_name: null,
                        last_name: null,
                      }));
                    }}
                  >
                    ثبت نام منشی
                    <img className="ms-2" src={AddCircleIcon} alt="" />
                  </div>
                </div>
                <div className="ps-2 col-6">
                  <div
                    className="btn btn-outline-primary w-100"
                    data-bs-toggle="modal"
                    data-bs-target={`#select-departments-modal-${props.id}`}
                    onClick={() => { }}
                  >
                    بازگشت
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* sign up secretary to department place modal */}
      <div
        className="modal fade"
        id={`add-secretary-modal-${props.id}`}
        tabIndex="-1"
        aria-labelledby={`add-secretary-modal-${props.id}-label`}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content border-radius-16">
            <div className="modal-header border-bottom m-3 mb-0 p-0 pb-2 fs-16 fw-medium color-bootstrap-gray-900">
              <div>
                <h5 className="fs-16 fw-medium mb-1">
                  ثبت منشی جدید در دپارتمان {headerTitle}
                </h5>
              </div>
              <img
                className="d-flex align-self-start"
                src={CancelIcon}
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>

            <div className="modal-body pt-2">
              <p className="fs-14 fw-normal mb-3 color-bootstrap-gray-700">
                اطلاعات منشی را با دقت وارد کنید
              </p>

              <div className="d-flex col mb-3 col-12">
                <input
                  className="form-control"
                  type="tel"
                  placeholder="شماره تماس"
                  // value={secretarySearch}
                  value={resultSecretary.mobile ? resultSecretary.mobile : ""}
                  onChange={(e) => {
                    setResultSecretary((prevState) => ({
                      ...prevState,
                      mobile: e.target.value,
                    }));
                  }}
                />
              </div>
              <div className="d-flex col mb-3 col-12">
                <input
                  className="form-control"
                  type="text"
                  placeholder="نام"
                  value={
                    resultSecretary.first_name ? resultSecretary.first_name : ""
                  }
                  onChange={(e) => {
                    setResultSecretary((prevState) => ({
                      ...prevState,
                      first_name: e.target.value,
                    }));
                  }}
                />
              </div>
              <div className="d-flex col mb-3 col-12">
                <input
                  className="form-control"
                  type="text"
                  placeholder="نام خانوادگی"
                  value={
                    resultSecretary.last_name ? resultSecretary.last_name : ""
                  }
                  onChange={(e) => {
                    setResultSecretary((prevState) => ({
                      ...prevState,
                      last_name: e.target.value,
                    }));
                  }}
                />
              </div>

              <div className="col-12 mt-2 px-0 d-flex">
                <div className="d-flex justify-content-center pe-2 col-6">
                  <button
                    className="btn btn-primary w-100"
                    data-bs-toggle="modal"
                    data-bs-target={`#add-remove-secretaries-modal-${props.id}`}
                    disabled={
                      !resultSecretary.mobile ||
                      resultSecretary.mobile.length != 11 ||
                      !resultSecretary.first_name ||
                      resultSecretary.first_name.length < 3 ||
                      !resultSecretary.last_name ||
                      resultSecretary.last_name.length < 3
                    }
                    onClick={() => {
                      addSecretaryToDepartmentPlaceAPI(
                        resultSecretary.mobile,
                        resultSecretary.first_name,
                        resultSecretary.last_name
                      );
                    }}
                  >
                    ثبت نام منشی
                    <img className="ms-2" src={AddCircleIcon} alt="" />
                  </button>
                </div>
                <div className="ps-2 col-6">
                  <div
                    className="btn btn-outline-primary w-100"
                    data-bs-toggle="modal"
                    data-bs-target={`#add-remove-secretaries-modal-${props.id}`}
                    onClick={() => { }}
                  >
                    بازگشت
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* add or remove department of place modal */}
      <div
        className="modal fade"
        id={`add-remove-departments-modal-${props.id}`}
        tabIndex="-1"
        aria-labelledby={`add-remove-departments-modal-${props.id}-label`}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header border-bottom mx-0 py-2">
              <ArrowRightAltIcon
                className="color-bootstrap-gray-800"
                width={24}
                height={24}
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
              <input
                type="text"
                className="form-control border-0 shadow-none w-100 color-iso-gray"
                placeholder="انتخاب دپارتمان ..."
                value={departmentSearch}
                onChange={(e) => setDepartmentSearch(e.target.value)}
              />
            </div>

            <div className="modal-body">
              {loading && (
                <span
                  className="spinner-border spinner-border ms-1"
                  role="status"
                  aria-hidden="true"
                />
              )}
              <div className="d-flex flex-column align-items-start">
                {assignedDepartments &&
                  assignedDepartments
                    .filter((department) =>
                      department.title.includes(departmentSearch)
                    )
                    .map((department, index) => {
                      return (
                        <div
                          className="btn-group w-100"
                          role="group"
                          aria-label="Basic mixed styles example"
                          key={index}
                        >
                          <button className="btn btn-light w-100 d-flex align-items-start my-2">
                            <div className="d-flex col">{department.title}</div>
                          </button>
                          <img
                            className="btn btn-light my-2"
                            src={RemoveIcon}
                            width={53}
                            // width={24}
                            alt=""
                            type="button"
                            onClick={() => {
                              removeDepartmentAPI(department);
                            }}
                          />
                        </div>
                      );
                    })}
              </div>
              <div className="d-flex flex-column align-items-start">
                {remainingDepartments &&
                  remainingDepartments
                    .filter((e) => e.title.includes(departmentSearch))
                    .map((department, index) => (
                      <div
                        className="btn-group w-100"
                        role="group"
                        aria-label="Basic mixed styles example"
                        key={index}
                      >
                        <button className="btn btn-light w-100 d-flex align-items-start my-2">
                          <div className="d-flex col">{department.title}</div>
                        </button>

                        <img
                          className="btn btn-light my-2"
                          src={AddIcon}
                          width={53}
                          type="button"
                          data-bs-toggle="modal"
                          data-bs-target={`#detail-modal-${props.id}`}
                          onClick={() => {
                            setDepartmentBio(
                              department.biography ? department.biography : ""
                            );
                            changeDepartment(department);
                          }}
                        />
                      </div>
                    ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* add detail of added department modal */}
      <div
        className="modal fade"
        id={`detail-modal-${props.id}`}
        tabIndex="-1"
        aria-labelledby={`detail-modal-${props.id}-label`}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header border-bottom mx-0 py-2 color-bootstrap-gray-800">
              <ArrowRightAltIcon
                width={24}
                height={24}
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
              <span className="w-100">اطلاعات دپارتمان {headerTitle}</span>
            </div>
            <div className="modal-body">
              {/* Detail inputs */}

              <div className="d-flex col mb-2 col-12">
                <input
                  className="form-control"
                  type="mobile"
                  placeholder="شماره تماس"
                  value={departmentPhone}
                  onChange={(e) => {
                    setDepartmentPhone(e.target.value);
                  }}
                />
              </div>

              <div className="d-flex col my-2 col-12">
                <textarea
                  className="form-control"
                  placeholder="توضیحات دپارتمان (اختیاری)"
                  value={departmentBio ? departmentBio : ""}
                  onChange={(e) => {
                    setDepartmentBio(e.target.value);
                  }}
                />
              </div>

              <button
                className="btn btn-primary w-100 d-flex align-items-center justify-content-center my-2"
                data-bs-toggle="modal"
                data-bs-target={`#add-remove-departments-modal-${props.id}`}
                onClick={() => {
                  addDepartmentAPI();
                  // setSelectedEducationId(education.id);
                  // setSelectedEducationTitle(education.title);
                  // if (selectedSpecialtyId) {
                  //   setAddtolist(true);
                  // }
                }}
              >
                افزودن دپارتمان {department.title}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// PlaceCard.propTypes = {
//   date: PropTypes.string,
//   day: PropTypes.string,
//   time: PropTypes.string,
//   turnStatus: PropTypes.string,
//   patientName: PropTypes.string,
//   patientTel: PropTypes.string,
//   doctorName: PropTypes.string,
//   department: PropTypes.string,
//   subDepartment: PropTypes.string,
//   turnType: PropTypes.string,
//   payment: PropTypes.string,
//   byWho: PropTypes.string,
// };

export default PlaceCard;
